export default "__VITE_PUBLIC_ASSET__520d9f61__"